function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import MUIButton from '@mui/material/Button';
export { buttonClasses } from '@mui/material/Button';
const ButtonFRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MUIButton, _extends({
  sx: {
    '&:hover': {
      boxShadow: 'none'
    },
    '&.Mui-focusVisible': {
      boxShadow: 'none'
    }
  }
}, props, {
  ref: ref
})));
export const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    variant = 'text',
    size = 'medium',
    ...props
  } = _ref;
  const allProps = {
    ...props,
    variant,
    size
  };
  return /*#__PURE__*/React.createElement(ButtonFRef, _extends({
    ref: ref
  }, allProps));
});
export default Button;